import React, { useEffect, useState } from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { IConstants, ISession } from '../../../models/pro-sites';
import TextInput from '../../inputs/text-input';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import 'react-datepicker/dist/react-datepicker.css';
import './workshop-request.css';
import {
    IWorkshopRequest,
    WorkshopRequestErrors,
    Address,
    WorkshopRequestDTO,
} from '../../../models/workshop-request';
import { matchesNameCode } from '../../../common';
import { loadConstants } from '../../../store/externals/externals-actions';
import { RootState } from '../../../store';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { FieldValidation, validate } from '../../../validation/validation';
import * as Validators from '../../../validation/validators';
import { IProfile } from '../../../models/profile';
import { loadProfile } from '../../../store/profile/profile-actions';
import { loadSession } from '../../../store/session/session-actions';
import { loadShipToAccounts } from '../../../store/account/account-actions';
import { IAccount } from '../../../models/company-account';
import { WorkshopRequestThankYouModal } from './workshop-request-thankyou';
import { submitWorkshopRequest } from '../../../api/workshop-request-api';

interface IWorkshopRequestProps {
    session: ISession | null;
    constants: IConstants | null;
    loadConstants: () => Promise<void>;
    workshopRequest: IWorkshopRequest;
    profile: IProfile | null;
    loadProfile: () => Promise<void>;
    loadSession: () => Promise<void>;
    shipToAccounts: IAccount[];
    loadShipToAccounts: () => Promise<void>;
    account: IAccount;
}

export const WorkshopRequest = ({
    session,
    constants,
    profile,
    shipToAccounts,
    loadConstants,
    workshopRequest,
    loadProfile,
    loadSession,
    loadShipToAccounts,
    account,
}: IWorkshopRequestProps) => {
    const intl = useIntl();
    const [errorsState, setErrorsState] = useState({});
    const [workshoprequestState, setWorkshopRequestState] = useState({
        ...workshopRequest!,
    });
    const [saving, setSaving] = useState(false);
    const [validating, setValidating] = useState(false);
    const [saveError, setSaveError] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [shipToAccount, setShipToAccount] = useState({ ...account! });
    const [fieldsInitialized, setFieldsInitialized] = useState(false);

    const currentDate = new Date();
    const minWorkshopDate = new Date(
        currentDate.setDate(currentDate.getDate() + 14)
    );
    const contactNameRequired = 'Contact Name is required';
    const accoountNumberRequired = 'Account Number is required';
    const phoneNumberRequired = 'Phone Number is required';
    const emailRequired = 'Email is required';
    const practiceNameRequired = 'Practice Name is required';
    const streetAddressRequired = 'Street Address is required';
    const cityRequired = 'City is required';
    const stateRequired = 'State is required';
    const postalCodeRequired = 'Postal Code is required';
    const workshopDate1Required = 'Workshop Date 1 is required';
    const unspecifiedError: any =
        'An unspecified error occurred submitting Workshop Request.';

    const isNuEar = window.location.href.includes('nuearpro');

    useEffect(() => {
        if (validating) {
            formIsValid();
        }
    }, [workshoprequestState]);

    useEffect(() => {
        if (!constants) {
            loadConstants();
        }
    });

    useEffect(() => {
        if (!profile) {
            loadProfile();
        }
    });

    useEffect(() => {
        if (!shipToAccounts || shipToAccounts.length === 0) {
            loadShipToAccounts();
        }
    });

    useEffect(() => {
        if (
            Object.keys(shipToAccount).length === 0 &&
            shipToAccounts.length > 0
        ) {
            setShipToAccount(
                shipToAccounts.find(
                    (x) => x.accountNumber === session!.account
                )!
            );
        }
    });

    useEffect(() => {
        if (
            !fieldsInitialized &&
            constants &&
            profile &&
            shipToAccounts.length > 0 &&
            Object.keys(shipToAccount).length > 0
        ) {
            setFieldsInitialized(true);
            setWorkshopRequestState({
                contactName: profile!.firstName + ' ' + profile!.lastName,
                title: '',
                accountNumber: session!.account,
                phoneNumber: profile!.phoneNumber,
                email: session!.userName,
                practiceName: shipToAccount.partyName,
                street1: profile!.street1,
                street2: profile!.street2,
                city: profile!.city,
                state: profile!.state,
                postalCode: profile!.postalCode,
            });
        }
    });

    const onChange = (event: any) => {
        const { name, value } = event.target;
        const val = name === 'state' ? value.toUpperCase() : value;
        const request = update(workshoprequestState, {
            [name]: { $set: val },
        });
        setWorkshopRequestState(request);
    };

    const onChangeDate1 = (
        _date: Date | null,
        event: React.SyntheticEvent<any, Event> | undefined
    ) => {
        onChangeDate(_date, 'workshopDate1');
    };

    const onChangeDate2 = (
        _date: Date | null,
        event: React.SyntheticEvent<any, Event> | undefined
    ) => {
        onChangeDate(_date, 'workshopDate2');
    };

    const onChangeDate3 = (
        _date: Date | null,
        event: React.SyntheticEvent<any, Event> | undefined
    ) => {
        onChangeDate(_date, 'workshopDate3');
    };

    const onChangeDate4 = (
        _date: Date | null,
        event: React.SyntheticEvent<any, Event> | undefined
    ) => {
        onChangeDate(_date, 'workshopDate4');
    };

    const onChangeDate = (date: Date | null, name: string) => {
        const request = update(workshoprequestState, {
            [name]: {
                $set: date,
            },
        });
        setWorkshopRequestState(request);
    };

    const fieldValidations = [
        new FieldValidation('contactName', 'Contact Name', [
            Validators.required(contactNameRequired),
        ]),
        new FieldValidation('accountNumber', 'Account Number', [
            Validators.required(accoountNumberRequired),
        ]),
        new FieldValidation('phoneNumber', 'Phone Number', [
            Validators.required(phoneNumberRequired),
        ]),
        new FieldValidation('email', 'Email', [
            Validators.required(emailRequired),
        ]),
        new FieldValidation('practiceName', 'Practice Name', [
            Validators.required(practiceNameRequired),
        ]),
        new FieldValidation('street1', 'Street Address', [
            Validators.required(streetAddressRequired),
        ]),
        new FieldValidation('city', 'City', [
            Validators.required(cityRequired),
        ]),
        new FieldValidation('state', 'State', [
            Validators.required(stateRequired),
        ]),
        new FieldValidation('postalCode', 'Postal Code', [
            Validators.required(postalCodeRequired),
        ]),
        new FieldValidation('workshopDate1', 'Workshop Date 1', [
            Validators.required(workshopDate1Required),
        ]),
    ];

    const formIsValid = (): boolean => {
        const validations = fieldValidations;

        const errors: WorkshopRequestErrors = validate(
            workshoprequestState,
            validations
        );

        setErrorsState(errors);

        return Object.keys(errors).length === 0;
    };

    const formInvalid = () => {
        const errorLength = Object.keys(errorsState).length;
        return errorLength > 0 && !(errorLength === 1 && saveError);
    };

    const save = async () => {
        try {
            setSaving(true);

            const address: Address = {
                City: workshoprequestState.city,
                PostalCode: workshoprequestState.postalCode,
                State: workshoprequestState.state,
                Street1: workshoprequestState.street1,
                Street2: workshoprequestState.street2,
            };
            const dto: WorkshopRequestDTO = {
                contactName: workshoprequestState.contactName,
                title: workshoprequestState.title,
                accountNumber: workshoprequestState.accountNumber,
                phoneNumber: workshoprequestState.phoneNumber,
                email: workshoprequestState.email,
                practiceName: workshoprequestState.practiceName,
                address: address,
                workshopDate1: workshoprequestState.workshopDate1
                    ? workshoprequestState.workshopDate1.toLocaleDateString()
                    : '',
                workshopDate2: workshoprequestState.workshopDate2
                    ? workshoprequestState.workshopDate2.toLocaleDateString()
                    : '',
                workshopDate3: workshoprequestState.workshopDate3
                    ? workshoprequestState.workshopDate3.toLocaleDateString()
                    : '',
                workshopDate4: workshoprequestState.workshopDate4
                    ? workshoprequestState.workshopDate4.toLocaleDateString()
                    : '',
            };

            const result = await submitWorkshopRequest(dto);

            if (result!.ok) {
                setValidating(false);
                setSaving(false);
                setFormSubmitted(true);
            } else {
                setSaving(false);
                setSaveError(unspecifiedError);
            }
        } catch (error) {
            setSaving(false);
            setSaveError(true);
        }
    };

    const handleSave = (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();
        setValidating(true);
        if (!formIsValid()) {
            return;
        }

        save();
    };

    const onCloseModal = () => {
        setSaving(false);
        setFormSubmitted(false);
        setWorkshopRequestState((prevState) => ({
            ...prevState!,
            workshopDate1: null,
            workshopDate2: null,
            workshopDate3: null,
            workshopDate4: null,
        }));
    };

    return (
        <>
            {session && constants && (
                <>
                    <form onSubmit={handleSave}>
                        <div>
                            <h1 className={isNuEar ? 'nuEar' : 'starkey'}>
                                <FormattedMessage
                                    id="Workshop_Request"
                                    defaultMessage="Workshop Request"
                                />
                            </h1>
                            <p>
                                <FormattedMessage
                                    id="Thank_you_for_your_interest"
                                    defaultMessage="Thank you for your interest in our Workshop
                                Consultation Programs. Please submit your
                                information below, and a workshop representative
                                will be in touch with you to confirm your
                                preferred dates."
                                />
                            </p>
                            <div className="well">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h3
                                            className={
                                                isNuEar
                                                    ? 'gutter-top underline forms nuear'
                                                    : 'gutter-top underline forms starkey'
                                            }
                                        >
                                            <FormattedMessage
                                                id="Contact_Information"
                                                defaultMessage="Contact Information"
                                            />
                                        </h3>
                                        <div
                                            className="form-horizontal"
                                            role="form"
                                        >
                                            <TextInput
                                                name="contactName"
                                                label={'Contact Name'}
                                                value={
                                                    workshoprequestState.contactName
                                                }
                                                maxLength={25}
                                                onChange={onChange}
                                                required={true}
                                                error={
                                                    !workshoprequestState.contactName &&
                                                    validating
                                                        ? contactNameRequired
                                                        : undefined
                                                }
                                            />
                                            <TextInput
                                                name="title"
                                                label={'Title'}
                                                value={
                                                    workshoprequestState.title
                                                }
                                                onChange={onChange}
                                                maxLength={30}
                                                required={false}
                                            />
                                            <TextInput
                                                name="accountNumber"
                                                label={'Account Number'}
                                                maxLength={5}
                                                value={
                                                    workshoprequestState.accountNumber
                                                }
                                                onChange={onChange}
                                                required={true}
                                                error={
                                                    !workshoprequestState.accountNumber &&
                                                    validating
                                                        ? accoountNumberRequired
                                                        : undefined
                                                }
                                            />
                                            <TextInput
                                                name="phoneNumber"
                                                label={'Phone Number'}
                                                maxLength={20}
                                                value={
                                                    workshoprequestState.phoneNumber
                                                }
                                                onChange={onChange}
                                                required={true}
                                                error={
                                                    !workshoprequestState.phoneNumber &&
                                                    validating
                                                        ? phoneNumberRequired
                                                        : undefined
                                                }
                                            />
                                            <TextInput
                                                name="email"
                                                label={'Email'}
                                                maxLength={100}
                                                value={
                                                    workshoprequestState.email
                                                }
                                                onChange={onChange}
                                                required={true}
                                                error={
                                                    !workshoprequestState.email &&
                                                    validating
                                                        ? emailRequired
                                                        : undefined
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <h3
                                            className={
                                                isNuEar
                                                    ? 'gutter-top underline forms nuear'
                                                    : 'gutter-top underline forms starkey'
                                            }
                                        >
                                            <FormattedMessage
                                                id="Location_Information"
                                                defaultMessage="Location Information"
                                            />
                                        </h3>
                                        <div
                                            className="form-horizontal"
                                            role="form"
                                        >
                                            <TextInput
                                                name="practiceName"
                                                label={'Practice Name'}
                                                maxLength={100}
                                                value={
                                                    workshoprequestState.practiceName
                                                }
                                                onChange={onChange}
                                                required={true}
                                                error={
                                                    !workshoprequestState.practiceName &&
                                                    validating
                                                        ? practiceNameRequired
                                                        : undefined
                                                }
                                            />
                                            <TextInput
                                                name="street1"
                                                label={'Address Line 1'}
                                                maxLength={30}
                                                value={
                                                    workshoprequestState.street1
                                                }
                                                onChange={onChange}
                                                required={true}
                                                error={
                                                    !workshoprequestState.street1 &&
                                                    validating
                                                        ? streetAddressRequired
                                                        : undefined
                                                }
                                            />
                                            <TextInput
                                                name="street2"
                                                label="Address Line 2"
                                                maxLength={30}
                                                value={
                                                    workshoprequestState.street2
                                                }
                                                onChange={onChange}
                                                required={false}
                                            />
                                            <TextInput
                                                name="city"
                                                label={'City'}
                                                maxLength={30}
                                                value={
                                                    workshoprequestState.city
                                                }
                                                onChange={onChange}
                                                required={true}
                                                error={
                                                    !workshoprequestState.city &&
                                                    validating
                                                        ? cityRequired
                                                        : undefined
                                                }
                                            />
                                            <TextInput
                                                name="state"
                                                label={'State'}
                                                maxLength={2}
                                                value={
                                                    workshoprequestState.state
                                                }
                                                onChange={onChange}
                                                required={true}
                                                error={
                                                    !workshoprequestState.state &&
                                                    validating
                                                        ? stateRequired
                                                        : undefined
                                                }
                                            />
                                            <TextInput
                                                name="postalCode"
                                                label={'Postal Code'}
                                                maxLength={10}
                                                value={
                                                    workshoprequestState.postalCode
                                                }
                                                onChange={onChange}
                                                required={true}
                                                error={
                                                    !workshoprequestState.postalCode &&
                                                    validating
                                                        ? postalCodeRequired
                                                        : undefined
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3
                                            className={
                                                isNuEar
                                                    ? 'gutter-top underline forms nuear'
                                                    : 'gutter-top underline forms starkey'
                                            }
                                        >
                                            <FormattedMessage
                                                id="Preferred_Workshop_Dates"
                                                defaultMessage="Preferred Workshop Dates"
                                            />
                                        </h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div
                                            className="form-horizontal"
                                            role="form"
                                        >
                                            <div
                                                className="col-sm-4"
                                                style={{
                                                    padding: '6px 12px',
                                                }}
                                            >
                                                <label className="control-label-wsr">
                                                    {intl.formatMessage({
                                                        id: 'FIRST',
                                                        defaultMessage: 'FIRST',
                                                    })}
                                                    :
                                                </label>
                                            </div>
                                            <div
                                                className="col-sm-8"
                                                style={{
                                                    padding: '6px 12px',
                                                }}
                                            >
                                                <DatePicker
                                                    className={
                                                        !workshoprequestState.workshopDate1 &&
                                                        validating
                                                            ? 'col-sm-8 date-picker-wsr-has-error'
                                                            : 'col-sm-8 date-picker-wsr'
                                                    }
                                                    selected={
                                                        workshoprequestState.workshopDate1
                                                    }
                                                    selectsStart={true}
                                                    name="workshopDate1"
                                                    onChange={onChangeDate1}
                                                    autoComplete="off"
                                                    isClearable={false}
                                                    showTimeSelect={false}
                                                    required={false}
                                                    popperPlacement="right"
                                                    minDate={minWorkshopDate}
                                                />
                                                <span
                                                    className="input-group-addon"
                                                    style={{
                                                        display: 'inline-block',
                                                        verticalAlign: 'top',
                                                        height: '34px',
                                                        backgroundColor:
                                                            !workshoprequestState.workshopDate1 &&
                                                            validating
                                                                ? '#f2dede'
                                                                : '#eee',
                                                        borderColor:
                                                            !workshoprequestState.workshopDate1 &&
                                                            validating
                                                                ? '#a94442'
                                                                : '#ccc',
                                                    }}
                                                >
                                                    *
                                                </span>
                                            </div>
                                            <div
                                                className="col-sm-4"
                                                style={{
                                                    padding: '6px 12px',
                                                }}
                                            >
                                                <label className="control-label-wsr">
                                                    {intl.formatMessage({
                                                        id: 'SECOND',
                                                        defaultMessage:
                                                            'SECOND',
                                                    })}
                                                    :
                                                </label>
                                            </div>
                                            <div
                                                className="col-sm-8"
                                                style={{
                                                    padding: '6px 12px',
                                                }}
                                            >
                                                <DatePicker
                                                    className="col-sm-8 date-picker-wsr"
                                                    selected={
                                                        workshoprequestState.workshopDate2
                                                    }
                                                    selectsStart={true}
                                                    name="workshopDate2"
                                                    onChange={onChangeDate2}
                                                    autoComplete="off"
                                                    isClearable={false}
                                                    showTimeSelect={false}
                                                    required={false}
                                                    popperPlacement="right"
                                                    minDate={minWorkshopDate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div
                                            className="form-horizontal"
                                            role="form"
                                        >
                                            <div
                                                className="col-sm-4"
                                                style={{
                                                    padding: '6px 12px',
                                                }}
                                            >
                                                <label className="control-label-wsr">
                                                    {intl.formatMessage({
                                                        id: 'THIRD',
                                                        defaultMessage: 'THIRD',
                                                    })}
                                                </label>
                                            </div>
                                            <div
                                                className="col-sm-8"
                                                style={{
                                                    padding: '6px 12px',
                                                }}
                                            >
                                                <DatePicker
                                                    className="col-sm-8  date-picker-wsr"
                                                    selected={
                                                        workshoprequestState.workshopDate3
                                                    }
                                                    selectsStart={true}
                                                    name="workshopDate3"
                                                    onChange={onChangeDate3}
                                                    autoComplete="off"
                                                    isClearable={false}
                                                    showTimeSelect={false}
                                                    required={false}
                                                    popperPlacement="left"
                                                    minDate={minWorkshopDate}
                                                />
                                            </div>
                                            <div
                                                className="col-sm-4"
                                                style={{
                                                    padding: '6px 12px',
                                                }}
                                            >
                                                <label className="control-label-wsr">
                                                    {intl.formatMessage({
                                                        id: 'FOURTH',
                                                        defaultMessage:
                                                            'FOURTH',
                                                    })}
                                                </label>
                                            </div>
                                            <div
                                                className="col-sm-8"
                                                style={{
                                                    padding: '6px 12px',
                                                }}
                                            >
                                                <DatePicker
                                                    className="col-sm-8 date-picker-wsr"
                                                    selected={
                                                        workshoprequestState.workshopDate4
                                                    }
                                                    selectsStart={true}
                                                    name="workshopDate4"
                                                    onChange={onChangeDate4}
                                                    autoComplete="off"
                                                    isClearable={false}
                                                    showTimeSelect={false}
                                                    required={false}
                                                    popperPlacement="left"
                                                    minDate={minWorkshopDate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {formInvalid() && (
                                <div className="alert alert-danger">
                                    <span>
                                        <FormattedMessage id="Please_enter_into_before_submitting" />
                                    </span>
                                </div>
                            )}
                            {saveError && (
                                <div className="alert alert-danger">
                                    <span
                                        style={{
                                            whiteSpace: 'pre-wrap',
                                        }}
                                    >
                                        {intl.formatMessage({
                                            id: 'Errors_on_save.',
                                            defaultMessage: ' Errors on save.',
                                        })}
                                    </span>
                                </div>
                            )}
                            <div className="gutter-top">
                                <button
                                    id="save-changes"
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    <span>
                                        {saving ? (
                                            <>
                                                {intl.formatMessage({
                                                    id: 'Saving',
                                                    defaultMessage: 'Saving',
                                                }) + '...'}
                                            </>
                                        ) : (
                                            <>
                                                {intl.formatMessage({
                                                    id: 'Submit_Workshop_Request',
                                                    defaultMessage:
                                                        'Submit Workshop Request',
                                                })}
                                            </>
                                        )}
                                    </span>
                                </button>
                            </div>
                        </div>
                        {formSubmitted && (
                            <WorkshopRequestThankYouModal
                                workshopRequest={workshoprequestState}
                                onAccept={() => undefined}
                                onClose={onCloseModal}
                                isNuEar={isNuEar}
                            />
                        )}
                    </form>
                </>
            )}
        </>
    );
};

const mapProfileFromState = (
    profile: IProfile | null,
    session: ISession | null,
    constants: IConstants | null
): IProfile | null => {
    if (!profile || !session || !constants) {
        return profile!;
    }

    const value = profile.country || session.country;
    const found = constants.countries.find(matchesNameCode(value));

    return found && profile.country === found.code
        ? profile
        : { ...profile, country: found ? found.code : undefined };
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session ? state.session.data! : null,
        constants: state.constants,
        profile: mapProfileFromState(
            state.profile ? state.profile.data! : null,
            state.session ? state.session.data! : null,
            state.constants
        ),
        shipToAccounts: state.shipToAccounts ? state.shipToAccounts.data! : [],
    };
};

const mapDispatchToProps = {
    loadConstants,
    loadProfile,
    loadSession,
    loadShipToAccounts,
};

const workshopRequestContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(React.memo(WorkshopRequest));

export default workshopRequestContainer;
